import apiFetch from '../../apiFetch'

export default function (paperworkId, lastAccessDate, token) {
  return apiFetch({ endPoint: `Dossier/Paperwork/${paperworkId}/ResendToProcessingAgency`, method: 'GET', body: null, token: token, lastAccessDate: lastAccessDate })
}
